import { toNumber } from '@lib/strings/toNumber';

const ONE_HUNDRED = 100;
const ROUND_UP_THRESHOLD = 5;

export const percentOfCurrency = (cents: number, percentage: number): number => {
  const resultParts = (cents * (percentage / ONE_HUNDRED)).toString().split('.');
  const integer = toNumber(resultParts[0]) ?? 0;
  return resultParts.length === 1 || (toNumber(resultParts[1]![0]) ?? 0) < ROUND_UP_THRESHOLD
    ? integer
    : integer + 1;
};
